import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mc-breadcrumb__container" }

import {
  type ComponentInternalInstance,
  getCurrentInstance,
  provide,
  ref,
} from 'vue';
import { childItemsInjectionKey, parentInjectionKey } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'MBreadcrumbV2',
  props: {
  /**
   * Enables the "dark mode" of the component to be used on dark backgrounds
   */
  dark: Boolean,
  /**
   * On lower resolutions allows to display only the previous level link of the current page
   * @see See [Documentation](https://mozaic.adeo.cloud/components/breadcrumb/code/#behaviours)
   */
  responsive: Boolean,
},
  setup(__props) {





provide(parentInjectionKey, getCurrentInstance()!);

const items = ref<ComponentInternalInstance[]>([]);
provide(childItemsInjectionKey, items);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([
      'mc-breadcrumb',
      {
        'mc-breadcrumb--dark': __props.dark,
        'mc-breadcrumb--responsive': __props.responsive,
      },
    ]),
    "aria-label": "Breadcrumb"
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})